import { useEffect } from 'react';
import { syncWagmiConfig } from './syncWagmiConfig.js';
export const useSyncWagmiConfig = (wagmiConfig, connectors, chains) => {
    useEffect(() => {
        if (chains?.length) {
            syncWagmiConfig(wagmiConfig, connectors, chains);
        }
    }, [chains, connectors, wagmiConfig]);
};
//# sourceMappingURL=useSyncWagmiConfig.js.map